<template>
  <div class="change-password">
    <div class="container">
      <ChangePasswordForm />
    </div>
  </div>
</template>

<script>
import ChangePasswordForm from '@/components/Auth/ChangePasswordForm.vue';

export default {
  components: {
    ChangePasswordForm,
  },
};
</script>

<style lang="sass" scoped>
.change-password
  padding-top: 80px
  @include l
    padding-top: 180px
  @include ms
    padding-top: 0
</style>
